import { render } from "./ManagerDashboard.vue?vue&type=template&id=e9a6552c&scoped=true"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js"

import "./ManagerDashboard.vue?vue&type=style&index=0&id=e9a6552c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a6552c"]])

export default __exports__